import React, { useEffect } from "react"

import { useHistory } from "react-router-dom";


function forwardToSubdomain()
{
    const url = 'http://shop.mentorg.org';
    window.location.href = url;
}





const Shop = (props) => {
    return (

        useEffect(()=>{
            forwardToSubdomain();
        }, []));
        
};

export default Shop;
